import { createStore } from "vuex";
import auth from "./modules/auth";
import parts from "./modules/parts";
import projects from "./modules/projects";
import team from "./modules/team";
import messages from "./modules/messages";
import crafts from "./modules/crafts";
import cities from "./modules/cities";
import craftsmen from "./modules/craftsmen";
import articles from "./modules/articles";
import colors from "./modules/colors";
import pictures from "./modules/pictures";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    parts,
    projects,
    team,
    messages,
    crafts,
    cities,
    craftsmen,
    articles,
    colors,
    pictures,
  },
});
